import { PriceHelper } from '../helpers/PriceHelper';
import { Config } from './../classes/Config';
import { BaseComponent } from './../classes/BaseComponent';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-also-included',
  templateUrl: './also-included.component.html',
  styleUrls: ['./also-included.component.scss']
})
export class AlsoIncludedComponent extends BaseComponent implements OnInit {

  @Input() bundle: any;
  @Input() country: string;
  @Input() useIvan: boolean;
  @Input() storeIsItunes: boolean;
  @Output() onClick = new EventEmitter();

  imageUrl: string = "";
  releaseYear: string = "";
  saveOpportunity: string = "";

  constructor() {
    super();
   }

  ngOnInit() {
    this.imageUrl = this.getItemImageUrl();
    this.releaseYear = this.bundle.releaseDate ? this.bundle.releaseDate.split('-')[0] : "";
    this.saveOpportunity = PriceHelper.formatPrice(this.bundle.saveOpportunity, this.bundle.currency);
  }

  getItemImageUrl(): string {

    let id = this.bundle.idInStore || this.bundle.itemID;
    if(id) {
      return Config.imageServerUrl + this.country + "/" + id + "/400x400.jpg";
    }
    return "";
  }

  bundleClick() {
    this.onClick.emit();
  }

  showHdQualityLogo(): boolean {
    if (!this.bundle) {
      return false;
    }

    const hasNo4K = this.bundle.has4K === null || this.bundle.has4K === undefined ||
      this.bundle.has4K === 0 || this.bundle.has4K === "0" ||
      this.bundle.has4K === false;
    return hasNo4K && this.hasHdBundlePrice();
  }

  hasHdBundlePrice(): boolean {
    if (!this.bundle || this.bundle.priceHd === null || this.bundle.priceHd === undefined ||
      this.bundle.priceHd === "") {
      return false;
    }

    const hdPrice = parseFloat(this.bundle.priceHd);
    return !isNaN(hdPrice) && hdPrice > 0;
  }

}
